export default __webpack_public_path__ + "static/media/img_demo_03.46448f7a.jpg";